<template>
  <div class="picker-container">
    <span class="span-title">
      {{ $t('orders.external_task_id') }}
    </span>
    <div
      v-if="assignedTasks.length > 0"
      class="nopads"
    >
      <div
        v-for="(eTask, index) in assignedTasks"
        :key="eTask.id"
        style="border-bottom: #d9d9d9 1px solid"
        class="row nopads pt-1 pb-1"
      >
        <div class="col-10 nopads">
          <span
            class="nopads col-10 pr-2"
            style="font-size: .9em"
          >
            {{ eTask.external_task_id }} - {{ eTask.external_task_descr }}
          </span>
        </div>
        <div class="col-2 nopads text-right">
          <button
            :id="'removeExternalTask' + eTask.id"
            class="pt-1 pb-1 mx-1 btn btn-sm btn-danger"
            @click.stop="removeExtTask(index)"
          >
            <i
              class="fa fa-trash"
              style="font-size: .8em; padding: 0; line-height: 1em;"
            />
          </button>
        </div>
      </div>
    </div>
    <div class="row nopads mt-2">
      <span class="col-9 nopads pr-2 tip-light">{{ $t('orders.external_task_hint') }}</span>
      <div class="col-3 text-right pt-2 nopads">
        <button
          class="btn btn-sm btn-info"
          @click.stop="fetchExtTasks"
        >
          {{ $t('common.add') }}
        </button>
      </div>
    </div>

    <!-- External task selection modal -->
    <base-modal
      v-if="showTaskModal"
      ref="extTaskModal"
      hide-footer
      class="nopads"
      :title="$t('orders.select_task')"
    >
      <external-task-selector
        ref="extTaskSelector"
        :tasks="extTasks"
        @notify-is-task-selected="handleIsTaskSelected"
      />
      <div class="col-12 button-container">
        <button
          class="form-button btn btn-sm btn-secondary"
          @click="showTaskModal = false"
        >
          {{ $t('common.cancel') }}
        </button>
        <button
          class="form-button btn btn-sm btn-success"
          :disabled="!isTaskSelected"
          @click="setExtTask()"
        >
          {{ $t('common.save') }}
        </button>
      </div>
    </base-modal>
    <div
      v-if="!!loading"
      class="spinner"
    />
  </div>
</template>

<script>

import { mapHelper } from "@/components/mixins/MapMixin";
import { restApi } from "@/components/mixins/RestApiMixin";
import ExternalTaskSelector from "@/components/velho/ExternalTaskSelector";
import BaseModal from "@/components/BaseModal.vue";

export default {
    name: 'HarjaTaskPicker',
    components: {BaseModal, ExternalTaskSelector},
    mixins: [mapHelper, restApi],
    props: {
        assignedTasks: {
            type: Array,
            default: () => []
        },
        contractId: {
            type: Number,
            default: null
        },
    },
    data() {
        return {
            loading: false,
            isTaskSelected: false,
            showTaskModal: false,
            extTasks: []
        }
    },
    methods: {
        fetchExtTasks() {
            this.loading = true
            this.restFetchParams(this.extTasksUrl, {contract: this.contractId}, this.handleTasks)
        },
        handleTasks(response) {
            this.loading = false
            if (response && response.data) {
                this.extTasks = response.data
                this.showTaskModal = true
            }
        },
        setExtTask() {
            let et = this.$refs.extTaskSelector.getSelectedTask()
            this.assignedTasks.push({
                'external_task_id': et.id,
                'external_task_descr': et.selite,
                'external_type': et.type
            })
            this.handleIsTaskSelected(false)
            this.showTaskModal = false
        },
        removeExtTask(index) {
            this.assignedTasks.splice(index, 1)
        },
        /**
         * Handle is task selected
         * @param {boolean} isSelected
         */
        handleIsTaskSelected(isSelected = false) {
            this.isTaskSelected = isSelected
        }
    }
}
</script>

<style scoped>
.picker-container {width: 100%;}
</style>
